/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Maincategory1Inputs */

const en_maincategory1 = /** @type {(inputs: Maincategory1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Main Category`)
};

const de_maincategory1 = /** @type {(inputs: Maincategory1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hauptkategorie`)
};

/**
* | output |
* | --- |
* | "Main Category" |
*
* @param {Maincategory1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const maincategory1 = /** @type {((inputs?: Maincategory1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Maincategory1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_maincategory1(inputs)
	return de_maincategory1(inputs)
});
export { maincategory1 as "mainCategory" }